import { rankingItems } from '@/mocks/homeData';

const tagColors: Record<string, string> = {
  '爆': 'bg-red-500',
  '热': 'bg-orange-500',
  '新': 'bg-accent-500',
};

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[900px] mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-4xl font-display text-foreground-950">
              今日热搜榜
            </h2>
            <p className="mt-2 text-sm md:text-base text-foreground-500">
              实时更新最热吃瓜内容，每分钟刷新热度数据
            </p>
          </div>

          <div className="bg-background-50 border border-background-200/70 rounded-lg overflow-hidden">
            {rankingItems.map((item) => (
              <div
                key={item.id}
                className="flex items-center gap-4 px-4 md:px-6 py-4 border-b border-background-100 last:border-b-0 hover:bg-background-100/50 transition-colors duration-200 cursor-pointer"
              >
                <div className={`w-8 h-8 rounded-md flex items-center justify-center font-display text-sm flex-shrink-0 ${
                  item.rank <= 3
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-200 text-foreground-600'
                }`}>
                  {item.rank}
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm md:text-base text-foreground-800 line-clamp-1">
                    {item.title}
                  </p>
                </div>
                <div className="flex items-center gap-2 flex-shrink-0">
                  <span className={`px-1.5 py-0.5 text-[10px] font-medium text-background-50 rounded-sm whitespace-nowrap ${tagColors[item.tag] || 'bg-background-400'}`}>
                    {item.tag}
                  </span>
                  <span className="text-xs text-foreground-400 whitespace-nowrap">
                    {item.hot}
                  </span>
                  <i className={`text-sm w-3 h-3 flex items-center justify-center ${
                    item.trend === 'up' ? 'ri-arrow-up-line text-red-500' : 'ri-arrow-up-line text-accent-500'
                  }`}></i>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}